angular.module('am4').controller('editContactCtrl', function() {});


// WEBPACK FOOTER //
// ./src/app/controllers/editContactCtrl.js